import { render, staticRenderFns } from "./AllFoldersGroups.vue?vue&type=template&id=dbfcff6a"
import script from "./AllFoldersGroups.vue?vue&type=script&lang=js"
export * from "./AllFoldersGroups.vue?vue&type=script&lang=js"
import style0 from "./AllFoldersGroups.vue?vue&type=style&index=0&id=dbfcff6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports